import React, { useState } from 'react';
import { environment } from '../../environment';

import {
  CustomerSelect,
  ChatBot,
  CreateTicketButton,
  ScheduleHelpButton,
  UserProfileModal,
} from '../../components/';

import { AppContext } from '../../AppContext';
import { canSeeFeature, FEATURE_LIST } from '../../permissions';
import { Popup, Menu } from 'semantic-ui-react';

function MainHeaderBar({
  firstName,
  lastName,
  company,
  onLogout,
  userId,
  customerId,
  isCorsicaUser,
  imitateClientId,
}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isUserProfileOpen, setIsUserProfileOpen] = useState(false);

  const handleMenuOpen = () => {
    setIsMenuOpen(true);
  };
  const handleMenuClose = () => {
    setIsMenuOpen(false);
  };

  const handleShowUserProfile = () => {
    setIsUserProfileOpen(true);
    // when user clicks menu button to open userprofile modal, close the dropdown popup
    setIsMenuOpen(false);
  };
  const handleHideUserProfile = () => {
    setIsUserProfileOpen(false);
  };

  return (
    <div className="app headerbar">
      <UserProfileModal
        isVisible={isUserProfileOpen}
        onClose={handleHideUserProfile}
      />
      <div className="headerbarLeft">
        <CustomerSelect />
      </div>
      <div className="headerbarRight">
        {canSeeFeature(FEATURE_LIST.CHATBOT) && <ChatBot />}
        <CreateTicketButton
          primary
          style={{ marginLeft: '15px' }}
          userFirstName={firstName}
          userLastName={lastName}
          company={company}
        />
        <ScheduleHelpButton />
        <span className="userGreeting">
          Hello, {firstName} {lastName}
        </span>

        <Popup
          trigger={
            <i
              style={{ lineHeight: '1rem' }}
              className="chevron down link icon"
            />
          }
          position="bottom right"
          style={{
            padding: '0 20px',
          }}
          basic
          on="click"
          open={isMenuOpen}
          onClose={handleMenuClose}
          onOpen={handleMenuOpen}
          content={
            <Menu text fluid vertical>
              {!isCorsicaUser && (
                <Menu.Item name="editProfile" onClick={handleShowUserProfile} />
              )}
              <Menu.Item name="logout" onClick={onLogout} />
            </Menu>
          }
        />
      </div>
    </div>
  );
}

const WrappedMainHeaderBar = props => (
  <AppContext.Consumer>
    {({ imitateClientId, userProfile }) => (
      <MainHeaderBar
        {...props}
        imitateClientId={imitateClientId}
        isCorsicaUser={
          userProfile?.client_id === environment.current.corsicaCustomerId
        }
      />
    )}
  </AppContext.Consumer>
);

export default WrappedMainHeaderBar;
